import {
  SAVE_AUDIENCE_REQUEST,
  SAVE_AUDIENCE_SUCCESS,
  SAVE_AUDIENCE_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const saveAudience = (state = initialState, action) => {
  const types = {
    [SAVE_AUDIENCE_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [SAVE_AUDIENCE_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [SAVE_AUDIENCE_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default saveAudience;
